export * from "./profile-info-full.component";
